<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> ADICIONAR PRODUTOS A COLEÇÃO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert type="success" v-if="successSave">
        <template v-slot:close>
          <v-icon @click="() => (successSave = false)"> mdi-close </v-icon>
        </template>
        Os Produtos Foram Adicionados a Coleção
      </v-alert>
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        v-if="page === 1"
      >
        <!-- <v-alert border="bottom" color="pink darken-1" dark v-if="error">
          <v-row align="center">
            <v-col class="grow">
              {{ error }}
            </v-col>
            <v-col class="shrink">
              <v-btn text icon @click="error = ''">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert> -->
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :loading="loadingCompany"
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Fornecedor"
                hide-details
                clearable
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :loading="loadingCollection"
                :items="collections"
                item-text="name"
                item-value="id"
                v-model="collection"
                label="Coleção"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :loading="loadingCategory"
                :items="categories"
                item-text="name"
                item-value="id"
                v-model="category"
                label="Categoria"
                @change="changeCategory"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :loading="loadingSubcategory"
                :items="subcategories"
                item-text="name"
                item-value="id"
                v-model="subcategory"
                label="Subcategoria"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-text-field
                v-model="reference"
                label="Referência"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :loading="loadingMaterial"
                :items="materials"
                item-text="name"
                item-value="id"
                v-model="material"
                label="Material"
                hide-details
                clearable
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :loading="loadingColor"
                :items="colors"
                item-text="name"
                item-value="id"
                v-model="color"
                label="Cor"
                hide-details
                clearable
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :loading="loadingTechnology"
                :items="technologies"
                item-text="name"
                item-value="id"
                v-model="technology"
                label="Tecnologia"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-btn color="blue darken-3" dark class="" @click="validate">
                <v-icon left>mdi-magnify</v-icon> Buscar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="text-h6">Produtos</label>
              <v-divider></v-divider>
              <v-alert border="bottom" color="pink darken-1" dark v-if="error">
                <v-row align="center">
                  <v-col class="grow">
                    {{ error }}
                  </v-col>
                  <v-col class="shrink">
                    <v-btn text icon @click="error = ''">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="green darken-3"
                outlined
                small
                @click="selectAll"
                v-if="
                  products.length > productsSelected.length ||
                  products.length == 0
                "
              >
                <v-icon left>mdi-checkbox-marked-outline</v-icon>
                Selecionar Todos
              </v-btn>
              <v-btn
                color="red darken-3"
                outlined
                small
                @click="deselectAll"
                v-if="
                  products.length === productsSelected.length &&
                  products.length > 0
                "
              >
                <v-icon left>mdi-checkbox-blank-outline</v-icon>
                Desmarcar Todos
              </v-btn>
              <v-btn
                color="blue darken-2"
                dark
                class="ml-5"
                small
                @click="addToCollection"
              >
                ADICIONAR A COLECÃO
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-simple-table fixed-header height="300px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">Referência</th>
                      <th class="text-left">Produto</th>
                      <th class="text-left">Fornecedor</th>
                      <th class="text-left">Coleção</th>
                      <th class="text-left">Categoria</th>
                      <th class="text-left">Subcategoria</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in products" :key="item.id">
                      <td>
                        <v-checkbox
                          :value="item"
                          v-model="productsSelected"
                        ></v-checkbox>
                      </td>
                      <td>{{ item.company_code }}{{ item.reference }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.company_code }} - {{ item.company }}</td>
                      <td>
                        <v-chip
                          @click="handleClickCollections(item)"
                          class="ma-2"
                          color="primary"
                          outlined
                          pill
                          label
                        >
                          {{ item.collections.length }}
                          {{
                            item.collections.length > 1 ? "Coleções" : "Coleção"
                          }}
                        </v-chip>
                      </td>
                      <td>{{ item.category }}</td>
                      <td>{{ item.subcategory }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="dialogAddToCollection" max-width="600px">
      <v-card>
        <v-toolbar color="blue lighten-1" dark class="text-h6">
          Adicionar Produtos a Coleção
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="4">
                <v-subheader>Selecione a Coleção</v-subheader>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <v-select
                  :items="collections"
                  item-text="name"
                  item-value="id"
                  v-model="collectionSelected"
                  label="Coleção"
                  required
                  return-object
                  hide-details
                  dense
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label for="">
                  Você tem certeza que deseja adicionar
                  <strong>{{ productsSelected.length }}</strong> produto(s) a
                  coleção <strong>{{ collectionSelected.name }}</strong
                  >?
                </label>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="greey darken-1" text @click="closeDialogAddToCollection"
            >Fechar</v-btn
          >
          <v-btn
            color="blue darken-1"
            dark
            @click="confirmDialogAddToCollection"
          >
            <v-icon dark>mdi-check</v-icon>
            Adicionar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCollectionsList" scrollable max-width="750px">
      <v-card>
        <v-card-title>Coleções</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Nome</th>
                  <th class="text-left">Data Alteração</th>
                  <th class="text-left">Atual</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="collection in productHasCollectionsSelected"
                  :key="collection.id"
                >
                  <td>{{ collection.collection.name }}</td>
                  <td>{{ collection.created_at }}</td>
                  <td v-if="getLastCollection(collection)">
                    <v-chip color="teal" class="ma-2" label text-color="white">
                      <v-avatar left>
                        <v-icon>mdi-checkbox-marked-circle</v-icon>
                      </v-avatar>
                      Atual
                    </v-chip>
                  </td>
                  <td v-else></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="dialogCollectionsList = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as CollectionProductAPI from "@/api/requests/CollectionProductRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as ColorAPI from "@/api/requests/ColorRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as SubcategoryAPI from "@/api/requests/SubcategoryRequest";
import * as MaterialAPI from "@/api/requests/MaterialRequest";
import * as ProductTechnologyAPI from "@/api/requests/ProductTechnologyRequest";

export default {
  components: {},
  data: () => ({
    page: 1,
    error: "",
    loading: false,
    companies: [],
    company: "",
    collections: [],
    collection: "",
    category: "",
    categories: [],
    subcategory: "",
    subcategories: [],
    reference: "",
    products: [],
    productsSelected: [],
    collectionSelected: {
      id: "",
      name: "",
    },
    technology: "",
    technologies: [],
    material: "",
    materials: [],
    color: "",
    colors: [],
    valid: true,
    lazy: false,
    successSave: false,
    loadingCompany: false,
    loadingCollection: false,
    loadingCategory: false,
    loadingSubcategory: false,
    loadingColor: false,
    loadingMaterial: false,
    loadingTechnology: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    dialogAddToCollection: false,
    dialogCollectionsList: false,
    productHasCollectionsSelected: [],
    dialogm1: "",
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.getCompanies();
      await this.getCollections();
      await this.getCategories();
      await this.getColors();
      await this.getMaterials();
      await this.getTechnologies();
    },
    validate() {
      if (this.$refs.form.validate()) {
        let dataSearch = {};
        dataSearch.type = "change-collection";
        dataSearch.company_id = this.company == null ? "" : this.company;
        dataSearch.collection_id =
          this.collection == null ? "" : this.collection;
        dataSearch.category_id = this.category == null ? "" : this.category;
        dataSearch.subcategory_id =
          this.subcategory == null ? "" : this.subcategory;
        dataSearch.material_id = this.material == null ? "" : this.material;
        dataSearch.color_id = this.color == null ? "" : this.color;
        dataSearch.technology_id =
          this.technology == null ? "" : this.technology;
        dataSearch.reference = this.reference == null ? "" : this.reference;
        // FAZER VALIDACAO PARA BUSCA
        let data = new URLSearchParams(dataSearch);

        this.search(data);
      }
    },
    goToBackList() {
      this.page = 1;
    },
    async search(data) {
      this.loading = true;
      this.products = [];
      this.productsSelected = [];
      try {
        let res = await fetch(`${URL}product/search-filters`, {
          method: "POST",
          body: data,
        });
        let response = await res.json();
        this.products = response.products;
      } catch (error) {
        console.log(error);
        // this.error = "Houve um error ao salvar, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    async getCompanies() {
      this.loadingCompany = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = {};
        console.log(error);
      } finally {
        this.loadingCompany = false;
      }
    },
    async getCollections() {
      this.loadingCollection = true;
      try {
        let data = await CollectionAPI.getAll();
        this.collections = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.collections = {};
        console.log(error);
      } finally {
        this.loadingCollection = false;
      }
    },
    async getCategories() {
      this.loadingCategory = true;
      try {
        let data = await CategoryAPI.getAll();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.categories = {};
        console.log(error);
      } finally {
        this.loadingCategory = false;
      }
    },
    async getMaterials() {
      this.loadingMaterial = true;
      try {
        let data = await MaterialAPI.getAll();
        this.materials = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.materials = {};
        console.log(error);
      } finally {
        this.loadingMaterial = false;
      }
    },
    async getTechnologies() {
      this.loadingTechnology = true;
      try {
        let data = await ProductTechnologyAPI.getAll();
        this.technologies = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.technologies = {};
        console.log(error);
      } finally {
        this.loadingTechnology = false;
      }
    },
    async getColors() {
      this.loadingColor = true;
      try {
        let data = await ColorAPI.getAll();
        this.colors = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.colors = {};
        console.log(error);
      } finally {
        this.loadingColor = false;
      }
    },
    async changeCategory() {
      this.loadingSubcategory = true;
      try {
        let data = await SubcategoryAPI.getAll(`?category_id=${this.category}`);
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.subcategories = {};
        console.log(error);
      } finally {
        this.loadingSubcategory = false;
      }
    },
    selectAll() {
      this.productsSelected = [...this.products];
    },
    deselectAll() {
      this.productsSelected = [];
    },
    addToCollection() {
      this.collectionSelected = {};
      if (this.productsSelected.length === 0) {
        this.error =
          "Selecione pelo menos 1 produto para poder mudar de coleção";
        return false;
      }
      this.dialogAddToCollection = true;
    },
    updatePrices() {
      // alert("ATUALIZAR PRECOS");
    },
    closeDialogAddToCollection() {
      this.dialogAddToCollection = false;
    },
    async confirmDialogAddToCollection() {
      let data = this.productsSelected.map((product) => ({
        product_id: product.id,
        collection_id: this.collectionSelected.id,
      }));
      // let myHeaders = new Headers({
      //   "Content-Type": "application/json",
      // });
      try {
        await CollectionProductAPI.post(data);

        // let res = await fetch(`${URL}collection-product`, {
        //   method: "POST",
        //   headers: myHeaders,
        //   body: JSON.stringify(data),
        // });
        // let response = await res.json();
        // console.log(response);
        this.dialogAddToCollection = false;
        this.successSave = true;
        this.products = [];
        this.productsSelected = [];
        this.company = "";
        this.category = "";
        this.collection = "";
        this.subcategory = "";
        this.material = "";
        this.color = "";
        this.reference = "";
        this.technology = "";
        this.collectionSelected = {};
      } catch (error) {
        console.log(error);
      }
    },
    handleClickCollections(item) {
      if (item.collections.length > 0) {
        this.productHasCollectionsSelected = item.collections;
        this.dialogCollectionsList = true;
      } else {
        this.productHasCollectionsSelected = [];
        this.dialogCollectionsList = false;
      }
    },
    getLastCollection(item) {
      console.log(item);
      return item.id === this.productHasCollectionsSelected[0].id;
    },
  },
};
</script>
